import type { ContainerType } from "~/container";
import type { IApi } from "~/interfaces/IApi";
import type { IRoleService } from "@saif-reporting/domain/interfaces/services/IRoleService.js";
import type { RoleDto } from "@saif-reporting/domain/dtos/models/RoleDto.js";
import type { RoleCreateRequest, RoleUpdateRequest } from "@saif-reporting/domain/dtos/roleDtos.js";

export class RoleService implements IRoleService {
  private readonly baseApi: IApi;

  constructor({ baseApi }: ContainerType) {
    this.baseApi = baseApi;
  }

  async getList(): Promise<RoleDto[]> {
    return await this.baseApi.$fetch<Array<RoleDto>>("/roles");
  }

  async getOne(id: number): Promise<RoleDto> {
    return await this.baseApi.$fetch<RoleDto>(`/roles/${id}`);
  }

  async create(dto: RoleCreateRequest) {
    return await this.baseApi.$fetch<RoleDto>(`/roles`, {
      method: "post",
      body: dto,
    });
  }

  async update(id: number, dto: RoleUpdateRequest) {
    return await this.baseApi.$fetch<RoleDto>(`/roles/${id}`, {
      method: "patch",
      body: dto,
    });
  }

  async delete(id: number): Promise<RoleDto> {
    return await this.baseApi.$fetch<RoleDto>(`/roles/${id}`, {
      method: "delete",
    });
  }
}
